import Injection from "./configs/injection";
import News from "./components/news/news";
import DocumentSearch from "./components/documentCentre/documentSearch";
import DocumentCentre from "./components/documentCentre/documentCentre";
import FavouritesDocument from "./components/documentCentre/favourites";
import Login from "./components/login/login";
import Application from "./components/application/application";
import Promotion from "./components/promotion/promotion";
import InstabilityMessages from "./components/instabilityMessages/instabilityMessages";
import UpcomingUnavailability from "./components/upcomingUnavailability/upcomingUnavailability";
import CorporateSearch from "./components/corporateSearch/corporateSearch";
import AdsSwitcher from "./components/ads/adsSwitcher";

Injection.registerInjection();
const webComponentFactory = new EECore.UI.WebComponentFactory();
const culture: EECore.Culture = EECore.Injection.Injector.resolve(EECore.Registrations.CULTURE);
EECore.Injection.Injector.resolve("WidgetTemplateLoader").load();
EECore.Injection.Injector.resolve("WidgetComponentLoader").load();

function loadLogin() {
  const loginContainers = document.querySelectorAll("ee-login");
  for (let i = 0; i < loginContainers.length; i++) {
    const loginComponent = webComponentFactory.getWebComponent(Login);
    const componentElement = loginComponent.load(loginContainers[i], culture.getCurrentCulture()) as Element;
    loginContainers[i].parentElement.replaceChild(componentElement, loginContainers[i]);
  }
}

function loadNews() {
  const newsContainer = document.querySelector("ee-news");
  if (newsContainer !== null) {
    const newsComponent = webComponentFactory.getWebComponent(News);
    const newsPromise = newsComponent.load(newsContainer, culture.getCurrentCulture()) as EECore.Promise<Element, string>;
    newsPromise.then((componentElement: Element) => {
      newsContainer.parentElement.replaceChild(componentElement, newsContainer);
    });
  }
}

function loadDocumentSearch() {
  const documentSearchContainers = document.querySelectorAll("ee-documentsearch");
  for (let i = 0; i < documentSearchContainers.length; i++) {
    const documentSearchComponent = webComponentFactory.getWebComponent(DocumentSearch);
    const componentElement = documentSearchComponent.load(documentSearchContainers[i], culture.getCurrentCulture()) as Element;
    documentSearchContainers[i].parentElement.replaceChild(componentElement, documentSearchContainers[i]);
  }
}

function loadDocumentCentre() {
  const documentCentreContainers = document.querySelectorAll("ee-documentcentre");
  for (let i = 0; i < documentCentreContainers.length; i++) {
    const documentCentreComponent = webComponentFactory.getWebComponent(DocumentCentre);
    const componentElement = documentCentreComponent.load(documentCentreContainers[i], culture.getCurrentCulture()) as Element;
    documentCentreContainers[i].parentElement.replaceChild(componentElement, documentCentreContainers[i]);
  }
}

function loadApplications() {
  const applicationsContainer = document.querySelector("ee-applications");
  if (applicationsContainer !== null) {
    const applicationComponent = webComponentFactory.getWebComponent(Application);
    const applicationPromise = applicationComponent.load(applicationsContainer, culture.getCurrentCulture()) as EECore.Promise<Element, string>;
    applicationPromise.then((componentElement: Element) => {
      applicationsContainer.parentElement.replaceChild(componentElement, applicationsContainer);
    });
  }
}

function loadPromotion() {
  const promotionContainer = document.querySelector("ee-promotion");
  if (promotionContainer !== null) {
    const promotionComponent = webComponentFactory.getWebComponent(Promotion);
    const promotionResult = promotionComponent.load(promotionContainer, culture.getCurrentCulture()) as EECore.Promise<Element, string> | Element;

    if (promotionResult instanceof EECore.Promise) {
      promotionResult.then((componentElement: Element) => {
        promotionContainer.parentElement.replaceChild(componentElement, promotionContainer);
      });
    }
    else {
      promotionContainer.parentElement.replaceChild(promotionResult, promotionContainer);
    }
  }
}

function loadInstabilityMessages() {
  const InstabilityMessagesContainer = document.querySelector("ee-instabilitymessages");
  if (InstabilityMessagesContainer) {
    const InstabilityMessagesComponent = webComponentFactory.getWebComponent(InstabilityMessages);
    const InstabilityMessagesComponentPromise = InstabilityMessagesComponent.load(InstabilityMessagesContainer, culture.getCurrentCulture()) as EECore.Promise<Element, string>;
    InstabilityMessagesComponentPromise.then((componentElement: Element) => {
      InstabilityMessagesContainer.parentElement.replaceChild(componentElement, InstabilityMessagesContainer);
    });
  }
}

function loadUpcomingUnavailability() {
  const UpcomingUnavailabilityContainer = document.querySelector("ee-upcomingUnavailability");
  if (UpcomingUnavailabilityContainer) {
    const UpcomingUnavailabilityComponent = webComponentFactory.getWebComponent(UpcomingUnavailability);
    const UpcomingUnavailabilityPromise = UpcomingUnavailabilityComponent.load(UpcomingUnavailabilityContainer, culture.getCurrentCulture()) as EECore.Promise<Element, string>;
    UpcomingUnavailabilityPromise.then((componentElement: Element) => {
      UpcomingUnavailabilityContainer.parentElement.replaceChild(componentElement, UpcomingUnavailabilityContainer);
    });
  }
}

function loadCorporateSearch() {
  const corporateSearchContainer = document.querySelector("ee-corporatesearch");
  if (corporateSearchContainer !== null) {
    const corporateSearchComponent = webComponentFactory.getWebComponent(CorporateSearch);
    const corporateSearchPromise = corporateSearchComponent.load(corporateSearchContainer, culture.getCurrentCulture()) as EECore.Promise<Element, string>;

    if (corporateSearchPromise instanceof EECore.Promise) {
      corporateSearchPromise.then((componentElement: Element) => {
        corporateSearchContainer.parentElement.replaceChild(componentElement, corporateSearchContainer);
      });
    }
    else {
      corporateSearchContainer.parentElement.replaceChild(corporateSearchPromise, corporateSearchContainer);
    }

  }
}

function loadAdsSwitchers() {
  const adsSlideshowContainers = document.querySelectorAll("ee-ads");
  for (let i = 0; i < adsSlideshowContainers.length; i++) {
    loadAdsSwitcher(adsSlideshowContainers[i]);
  }
}

function loadAdsSwitcher(container: Element) {
  const adsSlideshowComponent = webComponentFactory.getWebComponent(AdsSwitcher);
  const adsSlideshowPromise = adsSlideshowComponent.load(container, culture.getCurrentCulture()) as EECore.Promise<Element, string>;
  adsSlideshowPromise.then((componentElement: Element) => {
    container.parentElement.replaceChild(componentElement, container);
  });
}

function loadFavouritesDocument() {
  const containers = document.querySelectorAll("ee-favourites-document");
  for (let i = 0; i < containers.length; i++) {
    loadSingleFavouritesDocument(containers[i]);
  }
}

function loadSingleFavouritesDocument(container: Element) {
  const component = webComponentFactory.getWebComponent(FavouritesDocument);
  const promise = component.load(container, culture.getCurrentCulture()) as EECore.Promise<Element, string>;
  promise.then((componentElement: Element) => {
    container.parentElement.replaceChild(componentElement, container);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  loadLogin();
  loadNews();
  loadDocumentSearch();
  loadDocumentCentre();
  loadApplications();
  loadPromotion();
  loadInstabilityMessages();
  loadUpcomingUnavailability();
  loadCorporateSearch();
  loadAdsSwitchers();
  loadFavouritesDocument();
});

export = {
  loadLogin: loadLogin,
  loadNews: loadNews,
  loadDocumentSearch: loadDocumentSearch,
  loadDocumentCentre: loadDocumentCentre,
  loadApplications: loadApplications,
  loadPromotion: loadPromotion,
  loadInstabilityMessages: loadInstabilityMessages,
  loadCorporateSearch: loadCorporateSearch,
  loadAdsSlideshows: loadAdsSwitchers,
  loadFavouritesDocument: loadFavouritesDocument
};